import { RouteRecordRaw } from "vue-router";

const employees: RouteRecordRaw = {
  path: "employees",
  component: () => import("@/views/employees/index.vue"),
  meta: {
    title: "الموظفين",
  },
  children: [
    {
      path: "",
      alias: "index",
      name: "index-employees",
      component: () => import("@/views/employees/pages/index.vue"),
      meta: {
        pageId: 18010400,
        role: "view",
        title: "الموظفين",
      },
    },
    {
      path: "add",
      name: "add-employee",
      component: () => import("@/views/employees/pages/add.vue"),
      meta: {
        pageId: 18010400,
        role: "add",
        title: "AddNew",
      },
    },
    {
      path: "Edit/:Id",
      props: true,
      name: "edit-employee",
      component: () => import("@/views/employees/pages/add.vue"),
      meta: {
        pageId: 18010400,
        role: "edit",
        title: "Edit",
      },
    },
  ],
};

export default employees;
